import { Loader, ToastService } from "@launchmetrics/lm-ui";
import AdvancedTable from "components/LM/common/AdvancedTable";
import Breadcrumb from "components/LM/common/Breadcrumb";
import DateFormat from "components/LM/common/DateFormat";
import FormDatesSearch from "components/LM/common/FormDatesSearch";
import K2Api from "lib/ajax/K2Api";
import { useEffect, useState } from "react";
import { ArrowLeft } from 'react-feather';
import { Container } from "reactstrap";

const TABLE_COLUMNS = [
  {
    name: "actor",
    alias: "Actor"
  },
  {
    name: "message",
    alias: "Message"
  },
  {
    name: "date",
    alias: "Date"
  },
];


function VoiceLogs(props) {
  const { voiceId } = props;

  const [voice, setVoice] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const voice = await getVoiceInfo(voiceId);
        setVoice({ ...voice });
      } catch (err) {
        setError(err);
        ToastService.show({
          id: "fetch-voice-info-failed",
          title: "Failed to fetch voice info",
          type: "error",
        });
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [voiceId]);

  if (loading) return <Loader />;
  if (error) {
    return (
      <div>
        <h1>Error</h1>
        <p>{error.message}</p>
      </div>
    );
  }
  return (
    <div id={voiceId}>
      <Container fluid className="p-0">
        {breadcrumbPage(voice)}
        {voice ? (
          <h4 className="ml-3 mb-3">
            <a href={`/voices/${voice.id}`}>
              <ArrowLeft className="mr-1 mb-1" />
              {"Go back to voice"}
            </a>
          </h4>
        ) : null}
        <AdvancedTable
          columns={TABLE_COLUMNS}
          onSearch={(params) => voiceLogsSearch(voiceId, params)}
          onResults={processResponse}
        >
          <FormDatesSearch />
        </AdvancedTable>
      </Container>
    </div>
  );
}


function breadcrumbPage(voice) {
  const voiceLink = voice ? (
    <a href={`/voices/${voice.id}`} className="ml-1">
      {voice.name}
    </a>
  ) : null;
  return <Breadcrumb items={[voiceLink, "Audit logs"]} />;
}

async function getVoiceInfo(id) {
  const k2Api = new K2Api();
  const voice = await k2Api.get(`/voices/${id}`).catch((err) => {
    if (err.response.status !== 404) {
      throw new Error("Unexpected error getting voices");
    } else {
      return { data: null };
    }
  });
  return voice.data;
}

async function voiceLogsSearch(
  voiceId,
  { beginDate, endDate, page, pageSize }
) {
  const from = (page - 1) * pageSize;
  const request = { beginDate, endDate, from, size: pageSize };

  const k2Api = new K2Api();
  const response = await k2Api.get(`/voice/logs/${voiceId}`, { params: request });
  return response.data;
}

function processResponse(response) {
  const total = response.total;
  const rows = response.logs.map((row) => {
    return {
      ...row,
      id: row.date,
      date: <DateFormat>{row.date}</DateFormat>,
    };
  });
  return { total, rows };
}

export default VoiceLogs;
